//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

//FormulaBuilder components
import elementTypes from "../../Elements/elementTypes"
import DragOverlayDragIcon from "./DragOverlayDragIcon"

export default function DragOverLayOption({ draggedObject }) {
  if (draggedObject.formulaOrder) {
    let description = draggedObject.formulaOrder?.option?.title || "No title"

    return (
      <div className={myStyles.dragOverlyGeneral}>
        {description.length > 100
          ? description.substring(0, 100) + "..."
          : description}
      </div>
    )
  } else {
    return (
      <DragOverlayDragIcon
        icon={elementTypes.findTypeProfile(elementTypes.optionElementId)?.icon}
      />
    )
  }
}
